// import React from "react";
// import { Scrollbars } from "react-custom-scrollbars-2";
// import { Card, CardBody } from "@windmill/react-ui";
// import Title from "components/form/Title";
// import LabelArea from "components/form/LabelArea";
// import Error from "components/form/Error";
// import DrawerButton from "components/form/DrawerButton";
// import useAirportSubmit from "hooks/UseAirportSubmit";
// import InputAreaPrice from "components/form/InputAreaPrice";
// import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
// import InputName from "components/form/InputName";

// const AirportDrawer = ({ id }) => {
//   const {
//     register,
//     trigger,
//     handleSubmit,
//     onSubmit,
//     loading,
//     errors,
//     selectedCity,
//     setSelectedCity,
//   } = useAirportSubmit(id);

//   return (
//     <>
//       <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
//         {id ? (
//           <Title register={register} title="Edit Airport" />
//         ) : (
//           <Title register={register} title="Add Airport" />
//         )}
//       </div>
//       <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
//         <Card
//           className="flex-grow scrollbar-hide w-full max-h-full"
//           style={{ overflow: "visible" }}
//         >
//           <CardBody>
//             <form onSubmit={handleSubmit(onSubmit)}>
//               <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
//                 <div className="grid grid-cols-12 gap-5 mb-6 items-center">
//                   <div className="col-span-6">
//                     <LabelArea required label="Airport Code" />
//                     <InputName
//                       trigger={trigger}
//                       register={register}
//                       label="Airport"
//                       maxLength={6}
//                       name="airportcode"
//                       capitalize={true}
//                       type="text"
//                       placeholder="Eg: CBD"
//                     />
//                     <Error errorName={errors.airportcode} />
//                   </div>

//                   <div className="col-span-6">
//                     <LabelArea required label="Airport Name" />
//                     <InputName
//                       trigger={trigger}
//                       register={register}
//                       label="Airport Name"
//                       name="airportname"
//                       type="text"
//                       placeholder="Airport Name"
//                     />
//                     <Error errorName={errors.airportname} />
//                   </div>

//                   <div className="col-span-6">
//                     <LabelArea required label="City Name" />
//                     <SelectSingleCityOnly
//                       register={register}
//                       label="City Name"
//                       name={`cityname`}
//                       type="text"
//                       placeholder="--Choose--"
//                       selectedCity={selectedCity}
//                       handleCityChange={setSelectedCity}
//                     />
//                     <Error errorName={errors.cityname} />
//                   </div>

//                   <div className="col-span-6">
//                     <LabelArea required label="Parking Fee" />
//                     <InputAreaPrice
//                       trigger={trigger}
//                       register={register}
//                       label="Parking Fee"
//                       name="parking"
//                       required={true}
//                       type="text"
//                       placeholder="Parking Fee"
//                       maxLength={6}
//                     />
//                     <Error errorName={errors.parking} />
//                   </div>
//                 </div>
//               </div>

//               <DrawerButton
//                 isSubmitting={loading}
//                 id={id}
//                 title={id ? "Edit" : "Save"}
//               />
//             </form>
//           </CardBody>
//         </Card>
//       </Scrollbars>
//     </>
//   );
// };

// export default AirportDrawer;

import React, { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import useAirportSubmit from "hooks/UseAirportSubmit";
import InputAreaPrice from "components/form/InputAreaPrice";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import InputName from "components/form/InputName";
import VehicleCategoryServices from "services/VehicleCategoryServices";
import InputArea from "components/form/InputArea";

const AirportDrawer = ({ id }) => {
  const {
    register,
    trigger,
    handleSubmit,
    onSubmit,
    loading,
    errors,
    selectedCity,
    setSelectedCity,
  } = useAirportSubmit(id);

  const [allVehicleCategory, setVehicleCategory] = useState([]);

  useEffect(() => {
    async function fetchVehicleCategory() {
      try {
        const response = await VehicleCategoryServices.getAllVehicleCategory();
        setVehicleCategory(response.data);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    }

    fetchVehicleCategory();
  }, []);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Airport" />
        ) : (
          <Title register={register} title="Add Airport" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card
          className="flex-grow scrollbar-hide w-full max-h-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea required label="Airport Code" />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Airport"
                      maxLength={6}
                      name="airportcode"
                      capitalize={true}
                      type="text"
                      placeholder="Eg: CBD"
                    />
                    <Error errorName={errors.airportcode} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Airport Name" />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Airport Name"
                      name="airportname"
                      type="text"
                      placeholder="Airport Name"
                    />
                    <Error errorName={errors.airportname} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="City Name" />
                    <SelectSingleCityOnly
                      register={register}
                      label="City Name"
                      name={`cityname`}
                      type="text"
                      placeholder="--Choose--"
                      selectedCity={selectedCity}
                      handleCityChange={setSelectedCity}
                    />
                    <Error errorName={errors.cityname} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Latitude" />

                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Latitude"
                      name="latitude"
                      type="text"
                      placeholder="Latitude"
                      required={true}
                      // pattern={/^-?(90(\.0+)?|([0-8]?\d(\.\d+)?))$/}
                    />

                    <Error errorName={errors.latitude} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Longitude" />

                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Longitude"
                      name="longitude"
                      type="text"
                      placeholder="Longitude"
                      required={true}
                      // pattern={
                      //   /^-?(180(\.0+)?|1[0-7]\d(\.\d+)?|[0-9]?\d(\.\d+)?)$/
                      // }
                    />

                    <Error errorName={errors.longitude} />
                  </div>

                  {/* <div className="col-span-6">
                    <LabelArea required label="Parking Fee" />
                    <InputAreaPrice
                      trigger={trigger}
                      register={register}
                      label="Parking Fee"
                      name="parking"
                      required={true}
                      type="text"
                      placeholder="Parking Fee"
                      maxLength={6}
                    />
                    <Error errorName={errors.parking} />
                  </div> */}
                  {allVehicleCategory.map((vehicle) => (
                    <div className="col-span-6" key={vehicle.id}>
                      <LabelArea
                        required
                        label={`${vehicle.vehicle_type_name} Parking Fee`}
                      />

                      <InputAreaPrice
                        trigger={trigger}
                        register={register}
                        label={`${vehicle.vehicle_type_name} Parking Fee`}
                        name={`parking.${vehicle.id}`}
                        required={true}
                        type="text"
                        placeholder={`Enter ${vehicle.vehicle_type_name} Parking Fee`}
                        maxLength={6}
                      />

                      <Error errorName={errors?.parking?.[vehicle.id]} />
                    </div>
                  ))}
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Edit" : "Save"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default AirportDrawer;
